import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';

// import { colors } from '../../styles';


const styles = css`
  .PageContent_bodycopytitle, .PageContent_imagetitle, .PageContent_imagecontenttitle {
    margin-top: 2rem;
    font-weight: 700;
    font-size: 21px;
    line-height: 30px;
    color: rgb(0, 0, 0);
    letter-spacing: 2.5px;
    text-transform: uppercase;
  }
  .PageContent_imagecontenttitle {
    @media (min-width: 992px) {
      margin-top: 0;
    }
  }
  .PageContent_imagetitle {
    text-align: center;
    color: rgb(128, 128, 128);
    padding: 0px 0px 30px;
    margin: 0px;
  }
  .PageContent_lead {
    padding: 50px 15px;
  }
  .PageContent_imagesection p, .PageContent_lead p, .PageContent_bodycopy p {
    font-weight: 300;
    font-size: 18px;
    line-height: 35px;
    color: #212529;
  }
  .PageContent_bodycopy {
    padding: 20px 0 50px 0;
    } ul {
    padding-left: 0;
    padding-right: 2rem;
    list-style: none;
    }
    ul li::after {
    content: "";
    width: 10px;
    height: 10px;
    background-color: rgb(128, 128, 128);
    position: absolute;
    left: -30px;
    top: 9px;
  }
  .PageContent_bodycopy li {
    text-align: left;
    width: 100%;
    position: relative;
    font-weight: 300;
    font-size: 16px;
    line-height: 28px;
    padding: 0px 0px 20px;
    margin: 0px 0px 0px 30px;
}
  .PageContent_imagesection {
    @media (min-width: 992px) {
      padding: 40px 0 80px;
    }
  }
  .ContentVideo {
    margin: auto;
    padding-top: 50px;
  }
`;

function PageContent({ content }) {
  return (
    <div className={styles}>
      {
        get(content, 'video') &&
        <div className="ContentVideo container d-lg-flex flex-lg-row justify-content-center">
          <div className="VideoWrapper embed-responsive embed-responsive-16by9 col col-lg-6 mx-lg-1">
            <div className="embed-responsive-item" dangerouslySetInnerHTML={SanitizeHtml(get(content, 'video'))} />
          </div>
          {
            get(content, 'video_2') &&
            <div className="VideoWrapper embed-responsive embed-responsive-16by9 col col-lg-6 mx-lg-1 mt-1 mt-lg-0">
              <div className="embed-responsive-item" dangerouslySetInnerHTML={SanitizeHtml(get(content, 'video_2'))} />
            </div>
          }
        </div>
      }
      <div className="container">
        <div dangerouslySetInnerHTML={SanitizeHtml(get(content, 'lead_copy'))} className="col-lg-12  PageContent_lead" />
        <div className="d-lg-flex PageContent_imagesection">
          <div className="col-lg-5 order-lg-1">
            <h4 className="PageContent_imagetitle">{get(content, 'image_title')}</h4>
            <Image
              src={get(content, 'image.contentUrl')}
              alt="Page Content Icon"
              className="w-100"
            />
          </div>
          <div className="col-lg-6 mr-lg-auto">
            <h2 className="PageContent_imagecontenttitle">{get(content, 'image_content_title')}</h2>
            <div dangerouslySetInnerHTML={SanitizeHtml(get(content, 'image_content'))} />
          </div>
        </div>
        <div className="col-lg-12">
          <h3 className="PageContent_bodycopytitle">{get(content, 'body_copy_title')}</h3>
          <div dangerouslySetInnerHTML={SanitizeHtml(get(content, 'body_copy'))} className="PageContent_bodycopy" />
        </div>
      </div>
    </div>
  );
}

PageContent.propTypes = {
  content: PropTypes.object.isRequired,
};

export default PageContent;



// WEBPACK FOOTER //
// ./src/pages/AboutUs/PageContent.js